import { render } from "./EventsSwitch.vue?vue&type=template&id=0a850857&ts=true"
import script from "./EventsSwitch.vue?vue&type=script&lang=ts"
export * from "./EventsSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__